const $ = require('jquery');
const Mustache = require('mustache');
const mask = require('header.mask');
const headerAnalytics = require('header.analytics');
const storeFinderCore = require('header.storeFinder.core');
const data = require('header.data');
const config = {
  navigationListItemSelector: '.NavigationList__item',
  navigationDropdownSelector: '[data-js="navigation-links-dropdown"]',
  activeNavigationItemClass: 'NavigationList__item--active',
  activeNavigationItemSelector: '.NavigationList__item--active',
  navigationLinkSelectorThatIsNotAllProducts:
    '.NavigationList__item__link:not([data-id="departmentsFlyout"])',
  navigationDropdownItemSelector: '.NavigationList__dropdown__item',
  rightSideNavigationItemContainer: '#utility-links',
};
const navigationTemplate = `{{#navigationLinks}}
  <li class="NavigationList__item" {{#dropdownList}}data-js="navigation-links"{{/dropdownList}}>
    <a{{#id}} data-id="{{id}}"{{/id}} {{#linkDisable}} data-disablelink="{{linkDisable}}"{{/linkDisable}} class="NavigationList__item__link" href="{{link}}">{{title}}</a>
     {{#dropdownList}}
      <ul class="NavigationList__dropdown" data-js="navigation-links-dropdown">
        {{#dropdownListLinks}}
        <li class="NavigationList__dropdown__item">
          <a class="NavigationList__dropdown__link" href="{{link}}">{{label}}</a>
        </li>
        {{/dropdownListLinks}}
      </ul>
    {{/dropdownList}}
  </li>
{{/navigationLinks}}`;

class HeaderNavigationLinks {
  openDropdown() {
    if (storeFinderCore.isLocalizationDrawerOpen()) return;

    $(document).trigger('closeDrawer');
    $(document).trigger('closeAllMenusAndMask');
    const $NavigationItem = $(this).closest(config.navigationListItemSelector);
    const $dropdown = $NavigationItem.find(config.navigationDropdownSelector);
    if ($dropdown.length > 0) {
      $dropdown.css('display', 'block');
      mask.show();
      $NavigationItem.addClass(config.activeNavigationItemClass);
    }
  }

  handleNavigationLinkInteraction() {
    const $NavigationItem = $(this).closest(config.navigationListItemSelector);
    const thisUtilityDropdownIsAlreadyOpen =
      $NavigationItem.hasClass(config.activeNavigationItemClass) === true;
    if (!thisUtilityDropdownIsAlreadyOpen) {
      $(config.activeNavigationItemSelector).removeClass(
        config.activeNavigationItemClass,
      );
      $(document)
        .find(config.navigationDropdownSelector)
        .css('display', 'none');
      mask.show(null, false);
    }
  }

  closeDropdowns() {
    $(config.activeNavigationItemSelector).removeClass(
      config.activeNavigationItemClass,
    );
    $(document).find(config.navigationDropdownSelector).css('display', 'none');
  }

  logNavagationLinkInteraction() {
    const $NavigationLink = $(this);
    const isUtilityLink =
      $NavigationLink.closest(config.rightSideNavigationItemContainer)
        .length !== 0;
    const text = $NavigationLink.text().trim().replace('&', 'and');
    const eventText =
      'header>' + (!isUtilityLink ? 'shopping links>' + text : text);
    headerAnalytics.logEvent('header click', eventText);
  }

  logNavagationDropdownItemInteraction() {
    const $NavigationDropdownItem = $(this);
    const $NavigationLink = $NavigationDropdownItem
      .closest(config.navigationListItemSelector)
      .find(config.navigationLinkSelectorThatIsNotAllProducts);
    const isUtilityLink =
      $NavigationLink.closest(config.rightSideNavigationItemContainer)
        .length !== 0;
    const navigationLinkText = $NavigationLink
      .text()
      .trim()
      .replace('&', 'and')
      .concat('>');
    const navigationDropdownItemText = $NavigationDropdownItem.text().trim();
    const eventText =
      'header>' +
      (!isUtilityLink ? 'shopping links>' : '') +
      navigationLinkText +
      navigationDropdownItemText;
    headerAnalytics.logEvent('header click', eventText);
  }

  renderConfiguredNavigation() {
    const modifiedTemplate = navigationTemplate;
    data
      .getNavData()
      .then(function renderNavData(navData) {
        if (navData && !$.isEmptyObject(navData)) {
          const htmlContent = Mustache.render(modifiedTemplate, {
            navigationLinks: navData,
          });
          $('#navigationLinksNonUtil').empty().html(htmlContent);
        }
      })
      .catch(() => {});
  }

  init() {
    this.renderConfiguredNavigation();
    $(document)
      .on(
        'click touchend mouseover',
        config.navigationLinkSelectorThatIsNotAllProducts,
        this.handleNavigationLinkInteraction,
      )
      .on(
        'click touchend',
        config.navigationLinkSelectorThatIsNotAllProducts,
        this.logNavagationLinkInteraction,
      )
      .on(
        'click touchend',
        config.navigationDropdownItemSelector,
        this.logNavagationDropdownItemInteraction,
      )
      .on('click touchend', '#header-b2b', this.closeDropdowns)
      .on('searchState', this.closeDropdowns)
      .on('breakpointChanged', this.closeDropdowns)
      .on('closeNavLinkDropdowns', this.closeDropdowns)
      .on(
        'mouseenter',
        config.navigationLinkSelectorThatIsNotAllProducts,
        this.openDropdown,
      );
  }
}

module.exports = new HeaderNavigationLinks();
